<template>
    <router-view />
</template>
<script>
export default {
    name: "QualityControlSingle",
}; 
</script>
